export const readableTopic = {
  PRICING: 'Preisfindung',
  INHERITANCE: 'Erbschaft',
  DIVORCE: 'Scheidung',
  SALE: 'Verkauf',
  RENT: 'Vermietung',
  BUYING_INTEREST: 'Kaufinteresse',
  CREDIT: 'Finanzierung',
  REPLACEMENT: 'Ersatzbeschaffung',
  LIFE_ANNUITY: 'Leibrente',
  PARTIAL_SALE: 'Teilverkauf',
  PROPERTY_TAX: 'Grundsteuer',
  OTHER: 'Sonstiges'
}

export const readableCallbackTime = {
  FORENOON: 'Vormittags',
  NOON: 'Mittags',
  AFTERNOON: 'Nachmittags',
  EVENING: 'Abends'
}
